// extracted by mini-css-extract-plugin
export default {"graph":"styles_graph__EtMR2","wrap":"styles_wrap__tNL+4","content":"styles_content__zB48e","inner_content":"styles_inner_content__psRJt","canvasWrap":"styles_canvasWrap__vbmoE"};